#import "../fragments/audience-widget-fragment.graphql"

query GetContactAudiences($personId: ID!) {
    contact(id: $personId) {
        id
        name
        audienceMembershipsSubscribed {
            id
            audience {
                ...AudienceWidgetFragment
            }
        }
    }
}
